enum OrganizationErrorKey {
    NO_ORGANIZATION_FOUND_ERROR = "NoOrganizationFoundException",
}

export default OrganizationErrorKey;
